// AI-CONTEXT: See docs/features/output-registratie-per-keer-of-totaal.md (T4)
// Calendar periods for the period picker (DateRangeControl): whole quarters and
// years. Needed because the day-window presets only count back from today, and
// customers report per quarter and per year. Dates are local, never UTC.

/**
 * @typedef {object} CalendarPreset
 * @property {'thisQuarter'|'lastQuarter'|'thisYear'|'lastYear'} key - Passed to calendarPeriodRange
 * @property {string} label - Button text
 */

/** @type {CalendarPreset[]} */
export const calendarPeriodPresets = [
    { key: 'thisQuarter', label: 'Dit kwartaal' },
    { key: 'lastQuarter', label: 'Vorig kwartaal' },
    { key: 'thisYear', label: 'Dit jaar' },
    { key: 'lastYear', label: 'Vorig jaar' },
]

/**
 * @param {Date} d - A local date
 * @returns {string} 'YYYY-MM-DD' in local time
 */
export const toISODate = (d) => {
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
}

/**
 * Range from the first day of `startMonth` up to and including the last day
 * before `endMonth`. Month numbers may run outside 0–11; Date rolls the year.
 *
 * @param {number} year
 * @param {number} startMonth - 0-based
 * @param {number} endMonth - 0-based, exclusive
 * @returns {{ start: string, end: string }}
 */
const monthRange = (year, startMonth, endMonth) => ({
    start: toISODate(new Date(year, startMonth, 1)),
    end: toISODate(new Date(year, endMonth, 0)),
})

/**
 * The whole calendar period for a preset key, relative to `today`. A period
 * that is still running ends on its last day, not on today.
 *
 * @param {string} key - One of calendarPeriodPresets[].key
 * @param {Date} [today]
 * @returns {{ start: string, end: string } | null} null for an unknown key
 */
const calendarPeriodRange = (key, today = new Date()) => {
    const year = today.getFullYear()
    const quarterStart = Math.floor(today.getMonth() / 3) * 3
    switch (key) {
        case 'thisQuarter': return monthRange(year, quarterStart, quarterStart + 3)
        case 'lastQuarter': return monthRange(year, quarterStart - 3, quarterStart)
        case 'thisYear': return monthRange(year, 0, 12)
        case 'lastYear': return monthRange(year - 1, 0, 12)
        default: return null
    }
}

export default calendarPeriodRange
